export const getDataMixin = {
    computed:{
        // 拿到存储的导航数据
        getNvData(){
            return localStorage.getItem('navData') ? JSON.parse(localStorage.getItem('navData')) : ""
        },
        getNavIndex(){
            return this.$store.state.navIndex ? this.$store.state.navIndex : 1
        }
    },
}

import { payOrder, queryOrder } from "network/application.js"
import QRCode from "qrcodejs2";
export const payOrderPc = {
    data(){
        return {
            codeVisible:false, 
            queryTimer:'',
            codeOrderName:'',
            codePrice:''
        }
    },
    methods:{
        qrcode (codeUrl) {
            document.getElementById("qrcode").innerHTML = ""
            let qrcode = new QRCode("qrcode", {
                width: 200, // 像素
                height: 200,
                text:codeUrl
            });
            },
        // 生成付款码
        getPayOrder(orderNumber,orderName,price){
            this.codeOrderName = orderName
            this.codePrice = price
            payOrder({
                outTradeNo:orderNumber,
                tradeType:this.tradeType
            }).then(res=>{
                clearInterval(this.queryTimer)
                if(res.code == 1){
                    this.codeVisible = true
                    this.$nextTick(() => {
                        this.qrcode(res.data.codeUrl);
                    });
                    this.queryTimer = setInterval(()=>{
                        // 支付状态
                        this.queryOrder(orderNumber)
                    },2000)
                }
            })
        },
        // 查询订单是否支付
        queryOrder(orderNumber){
            queryOrder({
                outTradeNo:orderNumber
            }).then(res=>{
                if(res.code == 1 && res.data.tradeState == "SUCCESS"){
                    this.codeVisible = false
                    clearInterval(this.queryTimer)
                    this.$message({
                        type:'success',
                        message:'支付成功'
                    })
                    if(this.flag){
                        this.commonOrderList()
                        // console.log("我是订单列表")
                    }else{
                        // console.log("我是首页")
                        setTimeout(()=>{
                            this.orderText = "订单支付成功，是否查看订单详情？"
                            this.orderVisible = true
                        },100)
                    }
                   
                }
            })
        },
        handleClose(done){
            clearInterval(this.queryTimer)
            // 判读是首页还是订单列表页面
            if(!this.flag){
                this.orderText = "订单已生成，是否查看订单详情？"
                this.orderVisible = true
            }
            done();
        },
    }
}